"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.R = exports.liftHtml = exports.RxHtml = void 0;
const react_1 = __importDefault(require("react"));
const base_1 = require("./base");
class RxHtml extends base_1.RxWrapperBase {
    extractRxBaseProps(props) {
        return undefined;
    }
    extractProps({ props }) {
        return props || {};
    }
    extractComponent({ component }) {
        return component;
    }
}
exports.RxHtml = RxHtml;
function liftHtml(key) {
    function LiftedComponent(props) {
        return react_1.default.createElement(RxHtml, { component: key, props: props });
    }
    LiftedComponent.displayName = `lifted(${key})`;
    return LiftedComponent;
}
exports.liftHtml = liftHtml;
function liftAll(html) {
    const r = {};
    // @ts-ignore
    html.forEach(e => (r[e] = liftHtml(e)));
    return r;
}
const html = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
];
exports.R = liftAll(html);
